/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {
        path: '/create-rate',
        name: 'Create Rate',
        view: 'CreateRate'
    },
    {
        path: '/rate-report/:id',
        name: 'Rate Report',
        view: 'RateReport'
    },
]
